export const initializeOverflowContainers = () => {
    const fillRemainingWidthContainers = document.querySelectorAll('.js-fill-remaining-width');
    if (!fillRemainingWidthContainers.length) {
        return;
    }

    resizeContainers(fillRemainingWidthContainers);
    window.addEventListener("resize", () => resizeContainers(fillRemainingWidthContainers));

};

const resizeContainers = (fillRemainingWidthContainers) => {
    fillRemainingWidthContainers.forEach(container => {
        const rect = container.parentElement.getBoundingClientRect(); // The parent element doesn't have width changes so is a more trustworthy base
        const remainingWidth = window.innerWidth - rect.left;
        const rightPadding = window.innerWidth - rect.right;

        container.style.width = remainingWidth + 'px';
        container.style.paddingRight = rightPadding + 'px';
    });
}
